module.exports = __webpack_public_path__ + "7fb16989ac58ecda2119e1a94e372886.png";